import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

interface NavItem {
  path: string;
  label: string;
  badge?: number;
}

interface MobileNavDrawerProps {
  isOpen: boolean;
  isAnimating: boolean;
  onClose: () => void;
  onNavClick: () => void;
  isActive: (path: string) => boolean;
  navItems: NavItem[];
  onLogout: () => void;
}

export default function MobileNavDrawer({
  isOpen,
  isAnimating,
  onClose,
  onNavClick,
  isActive,
  navItems,
  onLogout,
}: MobileNavDrawerProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
          isAnimating ? 'opacity-50' : 'opacity-0'
        }`}
        onClick={onClose}
      />

      {/* Drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-xl transform transition-transform duration-300 z-50 ${
          isAnimating ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Drawer Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <h2 className="text-xl font-bold text-gray-900">Menu</h2>
            <button
              onClick={onClose}
              className="p-2 text-gray-600 hover:text-gray-900 focus:outline-none"
              aria-label="Close menu"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex flex-col p-4 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={onNavClick}
                className={`px-4 py-3 rounded-md text-base font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.label}
                {item.badge !== undefined && (
                  <span className="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-white text-[10px] font-semibold">
                    {item.badge}
                  </span>
                )}
              </Link>
            ))}
          </nav>

          {/* User Info & Logout */}
          <div className="mt-auto p-4 border-t">
            <button
              onClick={onLogout}
              className="w-full btn btn-secondary"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
